module.exports = __webpack_public_path__ + "static/media/logo.14c0646d.png";